(() => {
  if (window.__yyCartIntelligenceV2Loaded) return;
  window.__yyCartIntelligenceV2Loaded = true;

  const WISHLIST_KEY = 'm-wishlist-products';
  const rootUrl = () => window.Shopify?.routes?.root || '/';

  const getWishlist = () => {
    try {
      const parsed = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
      return Array.isArray(parsed) ? Array.from(new Set(parsed.filter(Boolean))) : [];
    } catch {
      return [];
    }
  };

  const writeWishlist = (products) => {
    const clean = Array.from(new Set((products || []).filter(Boolean)));
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(clean));

    try {
      window.MinimogTheme?.Wishlist?.updateWishlistCount?.();
      window.MinimogTheme?.Wishlist?.setWishlistButtonsState?.();
    } catch {}

    try {
      window.dispatchEvent(new StorageEvent('storage', {
        key: WISHLIST_KEY,
        newValue: JSON.stringify(clean)
      }));
    } catch {}

    document.dispatchEvent(new CustomEvent('wishlist:updated', {
      detail: { count: clean.length }
    }));

    return clean;
  };

  const addToWishlist = (handle) => {
    if (!handle) return getWishlist();

    try {
      if (window.MinimogTheme?.Wishlist?.addToWishlist) {
        window.MinimogTheme.Wishlist.addToWishlist(handle);
        window.MinimogTheme.Wishlist.updateWishlistCount?.();
        return getWishlist();
      }
    } catch {}

    const current = getWishlist();
    if (!current.includes(handle)) current.push(handle);
    return writeWishlist(current);
  };

  const syncEmptyWishlist = () => {
    const count = getWishlist().length;
    document.querySelectorAll('[data-yy-empty-wishlist-count]').forEach(el => {
      el.textContent = count ? '(' + count + ')' : '';
    });
  };

  const syncSaveButtons = () => {
    const saved = new Set(getWishlist());

    document.querySelectorAll('[data-yy-move-wishlist]').forEach(button => {
      const handle = button.dataset.productHandle;
      const label = button.querySelector('[data-yy-save-label]');
      const isSaved = saved.has(handle);

      button.classList.toggle('is-saved', isSaved);
      if (label && button.dataset.yyBusy !== 'true') {
        label.textContent = isSaved ? 'Saved' : 'Save for later';
      }
    });

    syncEmptyWishlist();
  };

  const moveToWishlist = async (button) => {
    if (!button || button.dataset.yyBusy === 'true') return;

    const handle = button.dataset.productHandle;
    const line = Number(button.dataset.line);
    const label = button.querySelector('[data-yy-save-label]');
    if (!handle || !line) return;

    button.dataset.yyBusy = 'true';
    button.disabled = true;
    if (label) label.textContent = 'Saving…';

    try {
      const response = await fetch(rootUrl() + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ line, quantity: 0 })
      });

      if (!response.ok) throw new Error('Unable to move item to wishlist');

      addToWishlist(handle);
      button.classList.add('is-saved');
      if (label) label.textContent = 'Saved ✓';

      const inDrawer = Boolean(button.closest('m-cart-drawer'));

      document.dispatchEvent(new CustomEvent('cart:refresh', {
        detail: { open: inDrawer }
      }));
      document.dispatchEvent(new CustomEvent('cart:updated'));

      if (!inDrawer && location.pathname.replace(/\/+$/, '') === '/cart') {
        setTimeout(() => location.reload(), 450);
      }
    } catch (error) {
      console.error('YETI YOGI save-for-later error:', error);
      button.disabled = false;
      button.dataset.yyBusy = 'false';
      if (label) label.textContent = 'Try again';
      return;
    }

    setTimeout(() => {
      button.disabled = false;
      button.dataset.yyBusy = 'false';
    }, 1200);
  };

  document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-yy-move-wishlist]');
    if (!button) return;
    event.preventDefault();
    moveToWishlist(button);
  });

  document.addEventListener('cart:refresh', () => setTimeout(syncSaveButtons, 850));
  document.addEventListener('cart:updated', () => setTimeout(syncSaveButtons, 500));
  document.addEventListener('wishlist:updated', syncSaveButtons);
  window.addEventListener('storage', event => {
    if (event.key === WISHLIST_KEY) syncSaveButtons();
  });

  const drawer = document.getElementById('MinimogCartDrawer');
  if (drawer && 'MutationObserver' in window) {
    let timer = null;
    const observer = new MutationObserver(() => {
      clearTimeout(timer);
      timer = setTimeout(syncSaveButtons, 120);
    });
    observer.observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncSaveButtons, { once: true });
  } else {
    syncSaveButtons();
  }
})();